<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('samples.nutrient_info') }}</p>
    <hr />
    <br />
    <template>
      <div class="custom-table-responsive table-responsive">
        <table
          class="table table-striped table-bordered table table-journals not-last-td"
        >
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('samples.nutrient') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.percentage') }} (%) *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index_num in nutrient_len" :key="index_num">
              <td class="text-center" style="min-width: 250px">
                <el-select
                  style="width: 70%; margin: auto"
                  clearable
                  filterable
                  class="select-primary custom-width-select required shadow-sm nut-add required-second-step"
                  size="large"
                  v-model="model.nutrients[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in availableNutrients"
                    class="select-primary"
                    :value="option.id"
                    :label="option.symbol + ' - ' + option.description"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 250px">
                <el-input
                  style="width: 50%; margin: auto"
                  clearable
                  class="select-primary text-center custom-width-select required shadow-sm nut-add required-second-step"
                  type="number"
                  min="0"
                  v-model="model.percentages[index_num - 1]"
                />
              </td>
              <td class="text-center vertical-custom" style="min-width: 100px">
                <div class="d-flex justify-content-center mt-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="nutrient_len++"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="nutrient_len > 1"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="handleDelete(index_num - 1)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-show="errorAlert">
        <div class="col-lg-12">
          <br />
          <el-alert
            ref="error_alert"
            :title="$t('common_words.errors')"
            type="error"
            >{{ error }}</el-alert
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        nutrients: [],
        percentages: [],
        fertilizer_nutrients_ids: [],
        fertilizer_nutrients_ids_bck: [],
      },
      nutrient_len: 1,
      all_nutrients: [],
    };
  },

  computed: {
    availableNutrients() {
      return this.all_nutrients.filter(
        (nutrient) => !this.model.nutrients.includes(nutrient.id)
      );
    },
  },

  mixins: [mixinMasters, MixinPermissions],

  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillFertilizerForm', 'secondStep');

        let total_percentajes = this.model.percentages.reduce(
          (a, b) => Number(a) + Number(b),
          0
        );

        if (total_percentajes > 100) {
          this.showError(
            'fer-date',
            'error-date',
            i18n.t('show_notification.fertilization.percentage_warning')
          );
          return false;
        } else {
          return this.validationInputsRequired('second-step');
        }
      });
    },

    handleDelete(indexnum) {
      try {
        this.model.nutrients.splice(indexnum, 1);
        let tmp = this.model.nutrients;
        this.model.nutrients = [];

        setTimeout(() => {
          this.model.nutrients = tmp;
        }, 10);
      } catch (error) {}

      try {
        this.model.percentages.splice(indexnum, 1);
      } catch (error) {}

      this.nutrient_len--;
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('fertilization/nutrients')
        .then((response) => {
          this.all_nutrients = response.data.data;

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            let editForm = JSON.parse(sessionStorage.getItem('editForm'));

            this.nutrient_len = 0;

            let tmp = [];
            editForm.fertilizer_nutrients.forEach((element) => {
              tmp.push(element.nutrient_id);
              this.model.percentages.push(element.percentage);
              this.model.fertilizer_nutrients_ids.push(element.id);
              this.model.fertilizer_nutrients_ids_bck.push(element.id);
              this.nutrient_len++;
            });

            setTimeout(() => {
              this.model.nutrients = tmp;
            }, 10);

            this.model.id = editForm.id;
            this.showHideLoading();
          } else {
            this.showHideLoading();
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
};
</script>
